export const defaultShippingAddress = {
    streetName: "",
    streetNumber: "",
    streetAdditional: "",
    postcode: "",
    city: "",
    countryCode: "",
    countryName: "",
    firstname: "",
    lastname: "",
    telephone: "",
};
export const defaultShippingContact = {
    firstname: "",
    lastname: "",
    telephone: "",
};
export const defaultBillingAddress = {
    streetName: "",
    streetNumber: "",
    streetAdditional: "",
    postcode: "",
    city: "",
    countryCode: "",
    countryName: "",
    firstname: "",
    lastname: "",
    telephone: "",
};
//# sourceMappingURL=defaultShippingFormValues.js.map